__turbopack_context__.v({
  "closeButton": "hotspot-viewer-module-scss-module__i-f5CW__closeButton",
  "hotSpotInfo": "hotspot-viewer-module-scss-module__i-f5CW__hotSpotInfo",
  "hotSpotTitle": "hotspot-viewer-module-scss-module__i-f5CW__hotSpotTitle",
  "hotspot": "hotspot-viewer-module-scss-module__i-f5CW__hotspot",
  "hotspotSection": "hotspot-viewer-module-scss-module__i-f5CW__hotspotSection",
  "hotspotViewer": "hotspot-viewer-module-scss-module__i-f5CW__hotspotViewer",
  "image": "hotspot-viewer-module-scss-module__i-f5CW__image",
  "imageWrapper": "hotspot-viewer-module-scss-module__i-f5CW__imageWrapper",
  "wrapper": "hotspot-viewer-module-scss-module__i-f5CW__wrapper",
});
